import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';

/**
 * Route guard factory: only activates if the named feature flag is enabled.
 * If the flag is off (or unknown), redirects to `/`. Compose with
 * `permissionGuard` for routes that need both — order doesn't matter since
 * Angular runs each guard independently and bails on the first redirect.
 */
export function featureFlagGuard(key: string): CanActivateFn {
  return () => {
    const flags = inject(FeatureFlagService);
    const router = inject(Router);
    if (flags.isEnabled(key)) {
      return true;
    }
    return router.createUrlTree(['/']);
  };
}
